export default __webpack_public_path__ + "static/media/Staff2.ded28bb1.JPG";